import { useLayoutEffect, useRef, useState } from 'react';
import { Router } from 'react-router-dom';
import { BrowserHistory, createBrowserHistory } from 'history';

interface Props {
  basename?: string;
  children: React.ReactNode;
}

// Can be used to manage navigation state outside of React components
export const customHistory = createBrowserHistory();

export function CustomBrowserRouter({ basename, children }: Props) {
  const historyRef = useRef<BrowserHistory | null>(null);
  if (!historyRef.current) {
    historyRef.current = customHistory;
  }
  const history = historyRef.current;
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router basename={basename} location={state.location} navigationType={state.action} navigator={history}>
      {children}
    </Router>
  );
}
